module.exports = __webpack_public_path__ + "static/media/harbor.55456174.png";